import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-CopyId",
  "use": "svg-icon-CopyId-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-CopyId\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.293 1.294l-3 3a1 1 0 0 0 1.414 1.413L7 4.415V10a1 1 0 1 0 2 0V4.415l1.293 1.292a1 1 0 1 0 1.414-1.414l-3-3m-1.414 0l.002-.002-.002.002zm.324-.217zM1 9v3a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V9a1 1 0 1 0-2 0v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 0-2 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol